import { twMerge } from "tailwind-merge";

import SquareButtonBG from "@/assets/img/layout/shared/square-button-bg.svg?react";

const SquareButton = (props: {
    children?: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    className?: string;
    backgroundColor: string;
}) =>
{
    const {
        backgroundColor, children, className,
    } = props;

    return (
        <div
            className={twMerge("relative", className)}
            onClick={(e) =>
            {
                if (props.onClick)
                {
                    props.onClick(e);
                }
            }}
        >
            <SquareButtonBG
                style={{
                    "color": backgroundColor,
                }}
            />
            <div
                className="
                    absolute
                    w-full
                    h-full
                    inset-0
                    flex
                    items-center
                    justify-center
                    whitespace-nowrap
                "
            >
                {children}
            </div>
        </div>
    );
};

export default SquareButton;
